/* plugins/myPlugin.js 自定义插件 */

import { post } from "./index.js";

// 自定义插件
export default {
  install: (Vue) => {
    // Vue 混入成员
    Vue.mixin({
      methods: {
        /**
         * 商户列表
         * @param {Number} type
         */
        async $getMerchantList(type = 1) {
          const { code, data } = await this.$post("manage/merch/getAllList", {
            type,
          });

          if (code === 200) {
            this.merchantList = data;
          }
        },
        /**
         * 获取类型列表
         */
        async $getTypeList() {
          const { code, data } = await this.$post("manage/shop/getShopType");

          if (code === 200) {
            this.typeList = data;
          }
        },
        /**
         * 省市区列表
         */
        async $getCityList(name = "tableData") {
          const { code, data } = await this.$post(
            "manage/common/getProvinceCityArea"
          );

          if (code === 200) {
            this[name] = data;
          }
        },
        /**
         * 获取分类列表
         */
        async $getProductTypeList() {
          const { code, data, total_number } = await post(
            "manage/product/getProductTypeList",
            this.pageData
          );

          if (code === 200) {
            this.tableData = data;

            this.pageData.total = total_number;
          }
        },
      },
    });
  },
};
